/** For use with metaTagPriorityByIndex values */
export enum ROLE_FORM_TYPE {
  TELESALES = 'telesales',
  CONSUMER = 'consumer',
  PRODUCER = 'producer'
}
